/**
 * React Query client singleton.
 *
 * Defaults are tuned for a field-use operations app:
 *   - retry on transient errors but don't hammer
 *   - no auto refetch on window focus (saves mobile battery)
 *   - 30s staleTime — assignment/status data updates frequently but not
 *     constantly; individual hooks override as needed
 */

import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry:                2,
      retryDelay:           (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      refetchOnWindowFocus: false,
      staleTime:            30 * 1000,
      gcTime:               5 * 60 * 1000,
    },
    mutations: {
      retry: 0,
    },
  },
})
